// Centralized auth token retrieval
// Demo viewers use sessionStorage (cleared on browser close)
// Regular users use localStorage (persists)
export function getToken() {
  return (
    sessionStorage.getItem('token') ||
    sessionStorage.getItem('authToken') ||
    sessionStorage.getItem('foundations-token') ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken') ||
    localStorage.getItem('foundations-token')
  );
}

export function isDemoViewer() {
  return localStorage.getItem('isDemoViewer') === 'true' || sessionStorage.getItem('isDemoViewer') === 'true';
}

// Clear all demo auth state (for logout)
export function clearDemoAuth() {
  ['isAuthenticated', 'userRole', 'authToken', 'token', 'foundations-token',
   'userId', 'userEmail', 'companyName', 'companyId', 'isDemoViewer',
   'activeSessionId', 'currentSessionId'].forEach(key => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
}
